import { render, staticRenderFns } from "./VideoPopup.vue?vue&type=template&id=df9c45f6&scoped=true"
import script from "./VideoPopup.vue?vue&type=script&lang=js"
export * from "./VideoPopup.vue?vue&type=script&lang=js"
import style0 from "./VideoPopup.vue?vue&type=style&index=0&id=df9c45f6&lang=scss&scoped=true"
import style1 from "./VideoPopup.vue?vue&type=style&index=1&id=df9c45f6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9c45f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df9c45f6')) {
      api.createRecord('df9c45f6', component.options)
    } else {
      api.reload('df9c45f6', component.options)
    }
    module.hot.accept("./VideoPopup.vue?vue&type=template&id=df9c45f6&scoped=true", function () {
      api.rerender('df9c45f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/VideoPopup.vue"
export default component.exports